module.exports = __webpack_public_path__ + "static/media/depaul.eb566619.png";